import SvgIcon from "@mui/material/SvgIcon";

export default function WaterAndSoilQualityIcon() {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: "24", height: "24", transform: "scale(1.8)" }}
    >
      <path
        d="M19.5 17.25H4.5C4.08579 17.25 3.75 17.5858 3.75 18C3.75 18.4142 4.08579 18.75 4.5 18.75H19.5C19.9142 18.75 20.25 18.4142 20.25 18C20.25 17.5858 19.9142 17.25 19.5 17.25Z"
        fill="#1C4321"
      />
      <path
        d="M9 6C9 4.75736 7.99264 3.75 6.75 3.75C5.50736 3.75 4.5 4.75736 4.5 6V15C4.5 16.2426 5.50736 17.25 6.75 17.25C7.99264 17.25 9 16.2426 9 15V6Z"
        fill="#F1EFF7"
      />
      <path
        d="M14.25 6C14.25 4.75736 13.2426 3.75 12 3.75C10.7574 3.75 9.75 4.75736 9.75 6V15C9.75 16.2426 10.7574 17.25 12 17.25C13.2426 17.25 14.25 16.2426 14.25 15V6Z"
        fill="#F1EFF7"
      />
      <path
        d="M19.5 6C19.5 4.75736 18.4926 3.75 17.25 3.75C16.0074 3.75 15 4.75736 15 6V15C15 16.2426 16.0074 17.25 17.25 17.25C18.4926 17.25 19.5 16.2426 19.5 15V6Z"
        fill="#F1EFF7"
      />
      <path
        d="M8.0625 3.75H5.4375C4.91973 3.75 4.5 4.16973 4.5 4.6875C4.5 5.20527 4.91973 5.625 5.4375 5.625H8.0625C8.58027 5.625 9 5.20527 9 4.6875C9 4.16973 8.58027 3.75 8.0625 3.75Z"
        fill="#E0DAEE"
      />
      <path
        d="M13.3125 3.75H10.6875C10.1697 3.75 9.75 4.16973 9.75 4.6875C9.75 5.20527 10.1697 5.625 10.6875 5.625H13.3125C13.8303 5.625 14.25 5.20527 14.25 4.6875C14.25 4.16973 13.8303 3.75 13.3125 3.75Z"
        fill="#E0DAEE"
      />
      <path
        d="M18.5625 3.75H15.9375C15.4197 3.75 15 4.16973 15 4.6875C15 5.20527 15.4197 5.625 15.9375 5.625H18.5625C19.0803 5.625 19.5 5.20527 19.5 4.6875C19.5 4.16973 19.0803 3.75 18.5625 3.75Z"
        fill="#E0DAEE"
      />
      <path
        d="M9 13.875C9 12.6324 7.99264 11.625 6.75 11.625C5.50736 11.625 4.5 12.6324 4.5 13.875V15C4.5 16.2426 5.50736 17.25 6.75 17.25C7.99264 17.25 9 16.2426 9 15V13.875Z"
        fill="#EFC52E"
      />
      <path
        d="M14.25 11.625C14.25 10.3824 13.2426 9.375 12 9.375C10.7574 9.375 9.75 10.3824 9.75 11.625V15C9.75 16.2426 10.7574 17.25 12 17.25C13.2426 17.25 14.25 16.2426 14.25 15V11.625Z"
        fill="#B69BDE"
      />
      <path
        d="M19.5 15C19.5 13.7574 18.4926 12.75 17.25 12.75C16.0074 12.75 15 13.7574 15 15C15 16.2426 16.0074 17.25 17.25 17.25C18.4926 17.25 19.5 16.2426 19.5 15Z"
        fill="#EFC52E"
      />
      <path
        d="M6.75 11.4375C7.06066 11.4375 7.3125 11.1857 7.3125 10.875C7.3125 10.5643 7.06066 10.3125 6.75 10.3125C6.43934 10.3125 6.1875 10.5643 6.1875 10.875C6.1875 11.1857 6.43934 11.4375 6.75 11.4375Z"
        fill="#F1EFF7"
      />
      <path
        d="M11.25 8.8125C11.5607 8.8125 11.8125 8.56066 11.8125 8.25C11.8125 7.93934 11.5607 7.6875 11.25 7.6875C10.9393 7.6875 10.6875 7.93934 10.6875 8.25C10.6875 8.56066 10.9393 8.8125 11.25 8.8125Z"
        fill="#F1EFF7"
      />
      <path
        d="M18 12.5625C18.3107 12.5625 18.5625 12.3107 18.5625 12C18.5625 11.6893 18.3107 11.4375 18 11.4375C17.6893 11.4375 17.4375 11.6893 17.4375 12C17.4375 12.3107 17.6893 12.5625 18 12.5625Z"
        fill="#F1EFF7"
      />
    </SvgIcon>
  );
}
